const dateLocaleOptions = (isSmallScreen) => {
  return {
    weekday: isSmallScreen ? 'short' : 'long',
    year: 'numeric',
    month: isSmallScreen ? '2-digit' : 'long',
    day: 'numeric'
  }
}
const capitalizeFirstLetter = (str) => {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const formatDate = (dateString, isSmallScreen) => {
  const rawDate = new Date(dateString).toLocaleDateString('fr-FR', dateLocaleOptions(isSmallScreen))
  return capitalizeFirstLetter(rawDate)
}

export const formatTime = (dateString) => {
  return new Date(dateString).toLocaleTimeString('fr-FR')
}
